/**
 * @file HeaderTopCustomSlot.tsx
 *
 * @fileoverview This component can be used to render custom things above the <header> part.
 */

export const HeaderTopCustomSlot = () => {
  return null;
};

export default HeaderTopCustomSlot;
